import screenfull from "screenfull";
import { AnalyticsActions } from "utils/Analytics";
import { useCallback, useState, useEffect } from "react";

export function useFullscreen() {
  const [isFullscreen, setIsFullscreen] = useState(screenfull.isFullscreen);

  const handleToggle = useCallback(() => {
    if (!screenfull.isEnabled) {
      return;
    }

    AnalyticsActions.fullscreenChange({
      fullscreen: !isFullscreen,
    });

    screenfull.toggle();

    if (isFullscreen) {
      // Requested cancel
      screenfull.exit();
    } else {
      // Request full screen
      screenfull.request();
    }
  }, [isFullscreen]);

  useEffect(() => {
    if (!screenfull.isEnabled) {
      return;
    }

    function changeHandler() {
      setIsFullscreen(screenfull.isFullscreen);
    }

    screenfull.on("change", changeHandler);

    return () => {
      screenfull.off("change", changeHandler);
    };
  });

  return {
    enabled: screenfull.isEnabled,
    isFullscreen,
    toggle: handleToggle,
  };
}
